module.exports = __webpack_public_path__ + "static/media/parquet.e05156dc.svg";